import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PaymentApi from "../../api/payment";
import ElectronicBankAccountApi from "../../api/electronic-bank-account";
import AuthContext from "../../components/auth-context";
import useAppNavigate from "../../components/router/use-app-navigate";
import { getMoneyText } from "../../functions";
import PaymentData from "../../types/payment-data";
import PurchaseTicketApi from "../../api/purchase-ticket";
import Ticket from "../../types/ticket";
import BankAccountData from "../../types/bank-account-data";
import BankAccountImage from "../payment/bank-account-Image";
import ShoppingIcon from "../payment/shopping-icon";
import LandingPaymentApi from "../../api/landing-payment";
export default function LandingPayment() {
  const { t } = useTranslation();
  const context = useContext(AuthContext);
  let { receiptId } = useParams();
  const [discountCode, setDiscountCode] = useState("");
  const [discountCodeErrorMessage, setDiscountCodeErrorMessage] = useState("");
  const [paymentData, setPaymentData] = useState<PaymentData | null>(null);
  const [bankAccountData, setbankAccountData] = useState<BankAccountData[]>([]);
  const [isCreditPayable, setIsCreditPayable] = useState(false);
  const [isDepositPayable, setIsDepositPayable] = useState(false);
  const discountCodeInput = useRef<HTMLInputElement | null>(null);
  const [ticket, setTickets] = useState<Ticket | null>(null);
  const [selectedBankId, setSelectedBankId] = useState<number>(2);
  let navigate = useAppNavigate();
  let epaymentAmount = 0;
  if (paymentData) {
    epaymentAmount = paymentData.payableAmount;
    if (isCreditPayable)
      epaymentAmount -= paymentData.profileInfo.creditPayable;
    if (isDepositPayable)
      epaymentAmount -= paymentData.profileInfo.depositPayable;
  }

  useEffect(() => {
    if (receiptId) {
      const paymentApi = new PaymentApi(context);
      paymentApi.get(receiptId, discountCode).then((data) => {
        if (data.errorMessage != null) {
          setDiscountCode("");
          discountCodeInput.current!.value = "";
          setDiscountCodeErrorMessage(data.errorMessage);
        } else {
          setPaymentData(data);
          setDiscountCode(data.discountCode);
        }
      });
    }
    // eslint-disable-next-line
  }, [receiptId, discountCode]);

  useEffect(() => {
    if (paymentData?.payableAmount) {
      let amount = paymentData.payableAmount;

      const electronicBankAccountApiApi = new ElectronicBankAccountApi(context);
      electronicBankAccountApiApi.get(amount, receiptId).then((data) => {
        // console.log(data);
        setbankAccountData(data);
      });
    }
    // eslint-disable-next-line
  }, [paymentData]);

  useEffect(() => {
    const purchaseTicketApi = new PurchaseTicketApi(context);
    purchaseTicketApi.getAll().then((data) => {
      context.setTickets(data);
      setTickets(data.length > 0 ? data[0] : null);
      // console.log("ticket", ticket);
    });
    // eslint-disable-next-line
  }, []);

  const getToman = (value: number) => {
    let money = getMoneyText(value);
    return `${money.amount} ${money.postFix}`;
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedBankId(+event.target.value);
  };

  const onsubmit = () => {
    const paymentApi = new LandingPaymentApi(context);
    paymentApi
      .put(
        receiptId!,
        discountCode,
        isDepositPayable,
        isCreditPayable,
        selectedBankId
      )
      .then((response) => {
        if (response.errorMessage != null)
          console.log("onsubmit", response.errorMessage);
        else if (epaymentAmount)
          window.location.replace(
            `//accounts.sepanta.com/payment/electronicpurchase/${receiptId}`
          );
        else navigate("/");
      });
  };
  return paymentData ? (
    <>
      <div className="d-flex flex-wrap justify-content-center">
        <div className="bg-white shadow-md rounded-lg p-4 max-w-[800px] w-full mx-auto overflow-y-scroll max-h-[550px]">
          <div
            className="d-flex text-light-tp text-100 border-bottom brc-transparent pt-3 pb-3 pr-3 mt-5 bgc-grey"
            style={{
              color: "#fff",
              fontSize: "15px",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{ float: "right" }}
            >
              <FontAwesomeIcon
                icon="cart-arrow-down"
                className="cart-arrow-down"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Filled"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                style={{ color: "#fff", marginLeft: "7px" }}
              >
                <path
                  d="M22.713,4.077A2.993,2.993,0,0,0,20.41,3H4.242L4.2,2.649A3,3,0,0,0,1.222,0H1A1,1,0,0,0,1,2h.222a1,1,0,0,1,.993.883l1.376,11.7A5,5,0,0,0,8.557,19H19a1,1,0,0,0,0-2H8.557a3,3,0,0,1-2.82-2h11.92a5,5,0,0,0,4.921-4.113l.785-4.354A2.994,2.994,0,0,0,22.713,4.077Z"
                  fill="#fff"
                />
                <circle cx="7" cy="22" r="2" fill="#fff" />
                <circle cx="17" cy="22" r="2" fill="#fff" />
              </svg>
            </div>
            <div className="ml-3 align-self-center">{paymentData!.topic}</div>
          </div>

          <table
            id="simple-table"
            className="payment-tb mb-0 table table-borderless table-bordered-x brc-secondary-l3 text-dark-m2 radius-1 overflow-hidden"
          >
            <tbody className="mt-1">
              <tr className="bgc-h-yellow-l4 d-style">
                <td className="text-right pr-25 pos-rel payment-title-td">
                  محصول
                </td>
                <td className="text-right pr-25 pos-rel payment-title-td">
                  قیمت
                </td>
              </tr>
              {ticket?.titles &&
                ticket?.titles.map((title, index) => (
                  <tr className="bgc-h-yellow-l4 d-style" key={index}>
                    <td className="text-right pr-25 pos-rel">{title}</td>
                    <td className="text-right pr-25 pos-rel payment-title-td">
                      {getToman(ticket?.prices[index])}
                    </td>
                  </tr>
                ))}
              {ticket?.commissions && (
                <>
                  {ticket.commissions.map((commission, index) => (
                    <tr className="bgc-h-yellow-l4 d-style" key={index}>
                      <td className="text-right pr-25 pos-rel payment-title-td">
                        کمیسیون {commission?.agentTitle}
                      </td>
                      <td>{getToman(commission?.amount)}</td>
                    </tr>
                  ))}
                </>
              )}
              {paymentData!.discount > 0 && (
                <tr className="bgc-h-yellow-l4 d-style">
                  <td className="text-right pr-25 pos-rel payment-title-td">
                    <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                    <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                    {t("Payment.Discount")}
                  </td>
                  <td className="text-right pr-25 pos-rel">
                    <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                    <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                    {getToman(paymentData!.discount || 0)}
                    {paymentData.discountCode &&
                      ` (${t("Payment.DiscountCode")}: ${
                        paymentData.discountCode
                      })`}
                  </td>
                </tr>
              )}
              <tr className="bgc-h-yellow-l4 d-style">
                <td className="text-right pr-25 pos-rel">
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                  {t("Payment.Tax")}
                </td>
                <td className="text-right pr-25 pos-rel payment-title-td">
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                  {getToman(paymentData!.taxAmount)}
                </td>
              </tr>
              <tr className="bgc-h-yellow-l4 d-style">
                <td className="text-right pr-25 pos-rel">
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                  {t("Payment.FinalPrice")}
                </td>
                <td className="text-right pr-25 pos-rel payment-title-td">
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                  {getToman(paymentData!.payableAmount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-white shadow-md rounded-lg p-4 max-w-[800px] w-full mx-auto">
          <table
            id="simple-table "
            aria-colspan={2}
            className="payment-tb payment3-tb mb-0 table table-borderless table-bordered-x brc-secondary-l3 text-dark-m2 radius-1 overflow-hidden"
          >
            <thead className="text-dark-tp3 text-90 border-b-1 brc-transparent bgc-grey">
              <tr
                className="row"
                style={{
                  color: "#fff",
                  fontSize: "15px",
                }}
              >
                <th>
                  <FontAwesomeIcon
                    icon="cart-arrow-down"
                    className="cart-arrow-down"
                  />{" "}
                  <ShoppingIcon />
                </th>
                <th> {t("Payment.Pay")}</th>
              </tr>
            </thead>
            <tbody className="mt-1">
              <tr className="bgc-h-yellow-l4 d-style">
                <td className="text-right pr-25 pos-rel ">
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                  <p>
                    در مجموع مبلغ{" "}
                    <strong>{getToman(paymentData!.payableAmount)}</strong>{" "}
                    پرداخت نمایید
                  </p>
                  <form className="form-inline">
                    {paymentData.discountCode?.length === 0 && (
                      <div className="form-group mb-2">
                        <div className="input-group mx-sm-1 mb-5 mt-5">
                          <input
                            ref={discountCodeInput}
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={t("Payment.DiscountCode")}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                console.log(discountCodeInput.current!.value);
                                setDiscountCode(
                                  discountCodeInput.current!.value
                                );
                              }}
                            >
                              {t("Payment.DiscountCodeSubmit")}
                            </button>
                          </div>
                        </div>
                        <div className="text-red-500 text-right">
                          {discountCodeErrorMessage}
                        </div>
                      </div>
                    )}
                  </form>
                  <form className="" style={{ marginTop: "15px" }}>
                    <div className="form-group  mb-2">
                      {paymentData!.profileInfo.depositPayable > 0 && (
                        <div className="form-check mb-5">
                          <input
                            className="form-check-input ml-3"
                            type="checkbox"
                            checked={isDepositPayable}
                            onChange={() =>
                              setIsDepositPayable(!isDepositPayable)
                            }
                            id="defaultCheck1"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="defaultCheck1"
                          >
                            پرداخت{" "}
                            <strong>
                              {getToman(
                                paymentData!.profileInfo.depositPayable
                              )}
                            </strong>{" "}
                            از موجودی اشتراک
                          </label>
                        </div>
                      )}
                      {paymentData.profileInfo.creditPayable > 0 && (
                        <div className="form-check mb-5">
                          <input
                            className="form-check-input ml-3"
                            type="checkbox"
                            checked={isCreditPayable}
                            id="defaultCheck2"
                            onChange={() =>
                              setIsCreditPayable(!isCreditPayable)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="defaultCheck2"
                          >
                            پرداخت{" "}
                            <strong>
                              {getToman(paymentData.profileInfo.creditPayable)}
                            </strong>{" "}
                            از موجودی اعتبار
                          </label>
                        </div>
                      )}
                      {paymentData.discountCode?.length !== 0 && (
                        <div className="form-check mb-5">
                          <label
                            className="form-check-label"
                            htmlFor="defaultCheck2"
                          >
                            کد تخفیف:
                            <strong>{paymentData.discountCode}</strong>
                          </label>
                        </div>
                      )}
                      {/* <div className="form-check">
                      <input
                        className="form-check-input ml-3"
                        type="checkbox"
                        value=""
                        id="defaultCheck3"
                        disabled
                        checked
                      />
                      <label
                        className="form-check-label"
                        htmlFor="defaultCheck3"
                      >
                        پرداخت <strong>{getToman(epaymentAmount)}</strong> بصورت
                        الکترونیکی
                      </label>
                    </div> */}
                      <div className="form-group mb-2 mt-2 row">
                        {paymentData &&
                          bankAccountData.length > 0 &&
                          bankAccountData
                            .filter((item) => {
                              if (!isDepositPayable) return true;
                              return item.id !== 10 && item.id !== 8;
                            })
                            .map(
                              (item) =>
                                item.title && (
                                  <div
                                    className="row d-flex mb-3"
                                    key={item.id}
                                    style={{ gap: "15px", flexWrap: "nowrap" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="paymentOption"
                                      id={`paymentOption${item.id}`}
                                      value={item.id}
                                      onChange={handleRadioChange}
                                      checked={item.id === selectedBankId}
                                      style={{ margin: 0 }}
                                    />
                                    {item.id !== 8 && (
                                      <BankAccountImage id={item.id} />
                                    )}
                                    <div>
                                      <strong className="mb-1 fs-6">
                                        {item.title}
                                      </strong>
                                      <p className="mb-0 fs-6">
                                        {item.description}
                                      </p>
                                    </div>
                                  </div>
                                )
                            )}
                      </div>
                    </div>
                  </form>
                </td>
              </tr>
              <tr className="bgc-h-yellow-l4 d-style">
                <td className="text-right pr-25 pos-rel ">
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover"></div>
                  <div className="position-tl h-100 ml-n1px border-l-4 brc-success-m1 v-active"></div>
                  <div className="form-group  col-12">
                    {/* <select id="inputState" className="form-control">
                    <option selected>دروازه پرداخت بانک پارسیان</option>
                    <option>...</option>
                  </select> */}
                    <button
                      className="btn btn-payment mt-2"
                      style={{ width: "inherit" }}
                      onClick={() => onsubmit()}
                    >
                      {t("Payment.Pay")}
                    </button>
                    <br />
                    <a href="https://accounts.sepanta.com/Files/police.docx">
                      <span
                        style={{
                          fontSize: "12.5px",
                          display: "block",
                          marginTop: "7px",
                          paddingRight: "5px",
                        }}
                      >
                        {t("Payment.Warning")}
                      </span>
                    </a>
                  </div>
                </td>
              </tr>

              {/* <tr className="border-0 detail-row bgc-white">
              <td aria-colspan={8} className="p-0 border-none brc-secondary-l2">
                <div className="table-detail collapse" id="table-detail-0">
                  <div className="row">
                    <div className="col-12 col-md-10 offset-md-1 p-4">
                      <div className="alert bgc-secondary-l4 text-dark-m2 border-none border-l-4 brc-primary-m1 radius-0 mb-0">
                        <h4 className="text-primary">Row Details</h4>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Quisque commodo massa sed ipsum porttitor facilisis.
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
